import {Component, EventEmitter, Output} from '@angular/core';
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'app-sales-client-verification',
  templateUrl: './sales-client-verification.component.html'
})
export class SalesClientVerificationComponent {
  requestId: string;
  type: string;
  @Output() nextStepEvent = new EventEmitter();

  constructor(private route: ActivatedRoute) {
    this.requestId = this.route.snapshot.params['request_id']
    this.type = this.route.snapshot.queryParams['type']
  }

  onNextStep() {
    this.nextStepEvent.emit();
  }
}
